import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { VehicleModel } from '../models/vehicle.model';
import { MakesAndModelsAddedByCSRSearchCriteria } from '../search/makes-and-models-added-by-csr/makes-and-models-added-by-csr-search-criteria.model';
import { Make } from '../models/make.model';
import { Observable } from 'rxjs';
import { ModelLookup } from '../models/model-lookup.model';

@Injectable({
    providedIn: 'root'
})
export class VehicleService extends BaseApiService {

    /*
    * holds the lookup data on the client side
    */

    private lookupData: any;

    /**
     * Clears the lookup data (invalidate the cache and force the getLookupData() to make a call to the server
     */
    resetLookupData(): void {
        const self = this;
        self.lookupData = null;
    }
    /**
     * Gets vehicle and it's brands
     * @param id
     */
    getVehicleInformation(id: number) {
        return this.get('Vehicle/Vehicle/' + id + '/Detail');
    }

    // gets the whole composite filled
    getVehicleComposite(id: number) {
        return this.get('Vehicle/Vehicle/' + id + '/Composite');
    }

    getActiveVehicleOwnershipByVehicleId(vehicleId: number) {
        return this.get('TitleRegistration/TitleRegistration/VehicleOwnership/Vehicle/' + vehicleId + '/Active');
    }

    getInProcesssBusinessTransactionWipStatuses(vehicleId: number) {
        return this.get('Vehicle/Vehicle/GetInProcesssBusinessTransactionWipStatuses/' + vehicleId);
    }

    getVehicleByBusinessTransactionId(businessTransactionNumberId: number) {
        return this.get('Vehicle/Vehicle/BusinessTransactionID/' + businessTransactionNumberId);
    }

    getIRPVehicleByBusinessTransactionId(businessTransactionNumberId: number) {
        return this.get('IRP/MotorCarrier/Vehicle/Transaction/' + businessTransactionNumberId);
    }

    getVehicleBrandsByVehicleId(vehicleId: number) {
        return this.get('Vehicle/Vehicle/' + vehicleId + '/Brands');
    }

    getAllBrands() {
        return this.get('Vehicle/Vehicle/Brands');
    }

    saveVehicleTransaction(businessTransactionId: number, vehicleModel: VehicleModel) {
        return this.post('TitleRegistration/TitleRegistration/Vehicle/Trn/' + businessTransactionId, vehicleModel);
    }

    getBrandsByVehicleType(vehicleId, vehicleTypeId) {
        return this.get('Vehicle/Vehicle/Vehicle/' + vehicleId + '/VehicleType/' + vehicleTypeId + '/Brands');
    }

    getNextBrandsByVehicleType(vehicleId: number, vehicleTypeId: number, brandId: number) {
        return this.get('Vehicle/Vehicle/Vehicle/' + vehicleId + '/VehicleType/' + vehicleTypeId + '/TransitionToBrands/' + brandId);
    }

    saveVehicle(vehicleModel: VehicleModel) {
        return this.post('Vehicle/Vehicle/Create/', vehicleModel);
    }

    saveMakeAndModel(vehicleId: number, makeId: number, modelId: number, modelYear: number) {
        return this.post('Vehicle/Vehicle/Update/' + vehicleId + '/MakeId/' + makeId + '/ModelId/' + modelId + '/Year/' + modelYear, null);
    }

    getNewVehicle(vin: string) {
        return this.get('Vehicle/Vehicle/Create/' + vin);
    }

    getNewVehicles(vin: string) {
        return this.get('Vehicle/Vehicle/NewVehicles/' + vin);
    }
    getTonnageDisplayValue(tonnageRatingTypeId: number) {
        return this.get('Vehicle/Vehicle/GetTonnageDisplayValue/' + tonnageRatingTypeId);
    }

    getTonnageValue(tonnageRatingDisplayTypeId: number) {
        return this.get('Vehicle/Vehicle/GetTonnageValue/' + tonnageRatingDisplayTypeId);
    }

    isDuplicateVin(vehicleId: number, vin: string, vinTypeId: number) {
        return this.get('Vehicle/Vehicle/' + vehicleId + '/VIN/' + vin + '/Type/' + vinTypeId + '/CheckDuplicate');
    }

    getMakeById(makeId: number) {
        return this.get('Vehicle/Make/' + makeId);
    }

    getMakesAndModelsAddedByCSR(searchCriteria: MakesAndModelsAddedByCSRSearchCriteria) {
        return this.post('Vehicle/Vehicle/AddedMakesAndModels/', searchCriteria);
    }

    getAllMakes() {
        return this.get('Vehicle/Make/All');
    }

    editModels(makeFrom: number, makeTo: Make) {
        return this.post('Vehicle/Model/EditModels/' + makeFrom, makeTo);
    }

    saveMake(make: Make) {
        return this.post('Vehicle/Make', make);
    }

    saveMakeWithNcic(make: Make) {
        return this.post('Vehicle/Make/New', make);
    }

    deleteVehicle(vehicleId: number) {
        return this.delete('Vehicle/Vehicle/' + vehicleId);
    }

    addModelToMake(model: ModelLookup): Observable<any> {
        return this.post('vehicle/model/', model);
    }

    getModelsByMakeId(makeId: Number) {
        return this.get('Vehicle/Make/' + makeId + '/models');
    }

    alterModelOnVehicles(model: any) {
        return this.post('Vehicle/Vehicle/AlterByModelId', model);
    }

    getBrandNMVITSBrandMaps() {
        return this.get('Vehicle/Vehicle/BrandNMVITSBrandMaps');
    }

    getActiveTransactionsByModelId(modelId: Number) {
        return this.get('Vehicle/Vehicle/ActiveTransactionsByModelId/' + modelId);
    }

    getActiveTransactionsByMakeId(makeId: Number) {
        return this.get('Vehicle/Vehicle/ActiveTransactionsByMakeId/' + makeId);
    }
}
